var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_830_115)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_830_115",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 50,
    height: 50
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.000144958H49.9999V50H0V0.000144958Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_830_115)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25 41.253V48.4951",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2812 49.0233H36.7187V43.164H13.2812V49.0233Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0982 33.3122C11.0301 31.5886 9.94372 29.3469 9.07634 27.1549C8.74548 26.3189 8.61599 25.4166 9.32409 24.8215C10.0322 24.2263 11.0793 24.3024 11.651 24.9906C12.199 25.6501 15.4429 29.7276 15.9908 30.387C19.0141 34.0259 24.4061 35.0502 24.9999 41.2529C25.5939 35.0502 30.9858 34.0259 34.0092 30.387C34.557 29.7276 37.8009 25.6501 38.3489 24.9906C38.9207 24.3024 39.9678 24.2263 40.6758 24.8215C41.3839 25.4166 41.2544 26.3189 40.9236 27.1549C40.0562 29.3469 38.9698 31.5886 37.9017 33.3122M41.0864 25.3827L45.662 17.8941C47.0932 15.6444 49.776 17.3711 48.8234 19.402C48.1565 20.7858 45.5131 27.3694 43.5279 31.7364C42.0999 34.8775 41.5235 35.6829 39.0028 37.9741L35.1709 41.4572V42.6173M8.91345 25.3827L4.33788 17.8941C2.90663 15.6444 0.223924 17.3711 1.17656 19.402C1.84335 20.7858 4.4867 27.3694 6.47205 31.7364C7.89997 34.8775 8.47634 35.6829 10.997 37.9741L14.829 41.4572V42.6173",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 24.4138C31.4544 24.4138 36.7187 19.1496 36.7187 12.6951C36.7187 6.24063 31.4544 0.976386 25 0.976386C18.5455 0.976386 13.2812 6.24063 13.2812 12.6951C13.2812 19.1496 18.5455 24.4138 25 24.4138Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5586 6.83573H27.4414V10.2537H30.8593V15.1365H27.4414V18.5544H22.5586V15.1365H19.1406V10.2537H22.5586V6.83573Z",
    stroke: "#4C4C4C",
    strokeWidth: 2,
    strokeMiterlimit: 22.926,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_830_115"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.c394d0161fee2eeaca6bbf849975aef5.svg";
export { ForwardRef as ReactComponent };